export function validatePhoneNumber(value) {
  if (value == null || value.trim().length === 0) {
    return "هذا الحقل مطلوب";
  }

  const phone = value.trim();

  if (phone.length !== 10) {
    return "رقم الهاتف يجب أن يكون 10 أرقام";
  }

  if (!phone.startsWith("09")) {
    return "رقم الهاتف يجب أن يبدأ بـ 09";
  }

  if (!/^[0-9]+$/.test(phone)) {
    return "رقم الهاتف يجب أن يحتوي على أرقام فقط";
  }

  return null;
}

export default validatePhoneNumber;
